import styled from 'styled-components'

export const Button = styled.button`
  position: absolute;
  top: 1vw;
  right: 1vw;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: .5rem;
  color: #fff;
  background: #181818;
`
